<template>
  <el-dialog
    :title="name"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <el-form
      ref="from"
      :model="params"
      label-width="auto"
      size="medium"
      :rules="rules"
    >
      <el-form-item label="角色名称" prop="name">
        <el-col :span="12">
          <el-input v-if="!isViewMode" v-model="params.name" />
          <template v-else>
            {{ params.name }}
          </template>
        </el-col>
      </el-form-item>
      <el-form-item label="角色说明">
        <el-col :span="12">
          <el-input v-if="!isViewMode" v-model="params.remark" />
          <template v-else>
            {{ params.remark }}
          </template>
        </el-col>
      </el-form-item>
      <el-form-item v-if="!isViewMode" label="继承角色">
        <el-select
          v-model="roleIds"
          filterable
          multiple
          placeholder="选择角色"
          style="width: 100%"
          @change="changeRole"
        >
          <el-option
            v-for="item in RoleLists"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="权限设置" prop="permissions">
        <div style="width: 100%; height: 400px; overflow-y: scroll">
          <el-tree
            :data="permissionTree"
            show-checkbox
            ref="tree"
            node-key="id"
          />
        </div>
      </el-form-item>
      <el-form-item label="合同权限">
        <div style="width: 100%; max-height: 400px; overflow-y: scroll">
        <el-tree
          :data="options"
          ref="treea"
          show-checkbox
          :props="defaultProps"
          :load="loadNode"
          node-key="id"
          lazy>
        </el-tree>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isViewMode" type="primary" plain @click="changeMode">编辑</el-button>
        <el-button v-else type="primary" plain @click="save">保存</el-button>
        <el-button plain @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import Http from "@/components/Admin/Flow/common/Http";
import tree from "@/assets/js/tree";
import _ from "lodash";
export default {
  name: "RoleDetail",
  props: {
    mode: {
      type: String,
      default: "add",
    },
    id: {
      type: Number | String,
      default: null,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      count: 1,
      permissionTree: [],
      params: {
        name: "",
        permissions: [],
        remark: "",
        checkedKeys: [],
        categoryIds: [],
      },
      pattern: "view",
      rules: {
        name: [{ required: true, message: "请填写角色名称", trigger: "blur" }],
        permissions: [
          { required: true, message: "请选择角色权限", trigger: "blur" },
        ],
      },
      RoleLists: [],
      roleIds: [],
      props2 : {
        multiple: true,
        checkStrictly: true,
      },
      valueStrictly:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options: [],
      // options : [
      //   {
      //     id:1,
      //     label: 'Guide',
      //     children: [],
      //   }],
    };
  },
  mounted() {
    var that = this;
    setTimeout(function () {
      // that.permissionTree = JSON.parse(JSON.stringify(__MENU_LIST__)); //tree
    }, 2000);
    this.getRoleList();
  },
  computed: {
    __MENU_LIST__() {
      return ERP.getStore().__MENU_LIST__;
    },
    isViewMode() {
      if (this.pattern === "view") {
        return true;
      }
      return false;
    },
  },
  watch: {
    id(n, o) {
      if (o === null) {
        return;
      }
      this.detail();
    },
    mode(n) {
      this.pattern = n;
      if (n === "add") {
        this.params = {
          name: "",
          permissions: [],
          remark: "",
          checkedKeys: [],
          categoryIds:[],
        };
        this.$refs.tree.setCheckedKeys(this.params.checkedKeys);
        this.$refs.treea.setCheckedKeys(this.params.categoryIds);
      }
    },
    __MENU_LIST__(n) {
      this.permissionTree = JSON.parse(JSON.stringify(n)); //tree
    },
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    detail() {
      if (this.id == null || this.id == 0) {
        return;
      }
      Http.post("flow/role/viewRole", { id: this.id }, (res) => {
        this.params = res.RoleInfo;
        this.$refs.tree.setCheckedKeys(this.params.checkedKeys);
        this.$refs.treea.setCheckedKeys(this.params.categoryIds);
      });
    },
    changeMode() {
      this.pattern = "edit";
    },
    save() {
      var url = "";
      if (this.pattern == "add") {
        url = "flow/role/addRole";
      } else {
        url = "flow/role/editRole";
      }
      if (this.id != null) {
        this.params.id = this.id;
      }
      var checkedKeys = this.$refs.tree.getCheckedKeys(); //获得全选状态id
      var halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys(); //获得半选状态的id
      var listKeys = checkedKeys.concat(halfCheckedKeys); //数组组合
      this.params.permissions = listKeys;
      this.params.checkedKeys = checkedKeys;
      this.params.valueStrictly = this.valueStrictly;
      const categoryIds = this.$refs.treea.getCheckedNodes(); // 获取所有选中的节点（包括半选节点）
      this.params.categoryIds = categoryIds;

      this.$refs["from"].validate((valid) => {
        if (valid) {
          Http.post(url, this.params, (res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.detail();
              this.handleClose();
            } else {
              this.$message.error(res.msg);
              this.handleClose();
            }
          });
        } else {
          return false;
        }
      });
    },
    getRoleList() {
      Http.post("flow/role/searchList", {}, (res) => {
        this.RoleLists = res.RoleInfos;
      });
    },
    changeRole(row) {
      let data = [];
      this.RoleLists.map((item) => {
        if (row.includes(item.id)) {
          data = _.concat(data, item.checkedKeys);
        }
      });
      data = _.uniq(data);
      data = _.concat(this.params.checkedKeys, data);
      this.$refs.tree.setCheckedKeys(data);
    },
    loadNode(node, resolve) {
      if (node.level === 0) { // 根节点，模拟异步加载子节点
        Http.get("flow/role/getContractList", {pid:0}, (res) => {
          return resolve(res.data); // 直接返回子节点数据，实际开发中应从服务器获取
        });
      }
      if (node.level > 0) { // 子节点，模拟异步加载子节点数据
        Http.get("flow/role/getContractList", {pid:node.data.id}, (res) => {
          resolve(res.data); // 直接返回子节点数据，实际开发中应从服务器获取
        });
      }
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/Role/RoleDetail.vue